<template>
  <router-view />
</template>

<script>
export default {};
</script>

<style lang="scss">
.box {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: center;
}

.items {
  padding-top: 25vh;
}

.text {
  padding-top: 5vh;
  width: 500px;
}

.spinner {
  margin-left: 22%;
}

.md-list-item-text {
  position: unset !important;
}
</style>
